import { groq } from 'next-sanity';
import { z } from 'zod';

import { link, SanityLink } from './link';

export const SanityButton = SanityLink.partial().extend({
  variant: z.enum(['primary', 'secondary', 'link']),
});
export type SanityButton = z.infer<typeof SanityButton>;

export const button = groq`{
  ...(link[0] ${link}),
  variant,
}`;
